import cx from 'classnames';
import CareemPlusIcon from 'packages/careem/home/components/CareemPlusCard/CareemPlusIcon';
import React from 'react';
import { Row } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

interface Props {
  total: number;
  percentage: number;
  icon?: JSX.Element;
  className?: string;
}

const StyledH5 = styled.h5`
  margin: 0px;
  margin-left: 8px;
  color: ${({ theme }) => theme.text.success};
  font-weight: 500;
`;

const AdditionalPercentageOff: React.FC<Props> = ({ total, percentage, icon = <CareemPlusIcon />, className = '' }) => {
  const { t } = useTranslation();

  return (
    <Row noGutters className={cx('d-flex align-items-center mt-3', className)}>
      {icon}
      <StyledH5>{t('pricingPage.careemPlusInfo', { percentage, total })}</StyledH5>
    </Row>
  );
};

export default AdditionalPercentageOff;
